exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=date]::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  display: none;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main